import { render } from "./TermOfUser.vue?vue&type=template&id=392efe8c"
const script = {}

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__